import { render } from "./NewNode.vue?vue&type=template&id=6e7ec49e&scoped=true"
const script = {}

import "./NewNode.vue?vue&type=style&index=0&id=6e7ec49e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7ec49e"]])

export default __exports__